<template>
  <div :class="noBorder ? 'tip' : 'tip border'">
    <span class="light">
      <img alt="light" src="../../assets/light@3x.png" />
    </span>
    <span class="text">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: 'VvSingleTip',
  props: {
    label: String,
    noBorder: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>

.tip {
  display: flex;
  align-items: center;
  text-align: left;
  padding: 14px 0px;

  &:first-child {
    border-top: none;
  }
}

.border {
  border-top: 2px solid rgba(209, 209, 209, 0.28);
}

.light {
  margin-right: 13px;

  img {
    width: 20px;
    height: 24px;
  }
}
</style>
